import {ApiError, apiFetch} from "../client";
import {apiErrorCode} from "../error-codes";
import {formatApiError} from "./errors";

// Вывод балансов командам: привязка адреса вывода и рабочий экран «кому и
// сколько отправлять». Деньги отправляет админ руками с кошелька; система
// только фиксирует запрос, ждёт поступление на адреса команды и обнуляет
// долг сама. Суммы приходят готовыми десятичными строками USDT — в number их
// не парсим.

export interface TeamPayoutAddress {
    id: string;
    network: "trc20";
    address: string;
    activeFrom: string;
    enabled: boolean;
    disabledAt: string | null;
}

export interface TeamWithdrawalPendingItem {
    id: string;
    teamId: string;
    teamName: string;
    amount: string;
    received: string;
    currency: string;
    network: string;
    address: string;
    createdAt: string;
}

export interface TeamWithdrawalPendingResponse {
    items: TeamWithdrawalPendingItem[];
}

// Адресов у команды может быть несколько: команде платят на разные её кошельки,
// и поступление на любой из них гасит её запрос вывода. Новый — сверху.
export function listTeamPayoutAddresses(token: string | null, teamId: string): Promise<TeamPayoutAddress[]> {
    return apiFetch<{items: TeamPayoutAddress[]}>(`/teams/${encodeURIComponent(teamId)}/payout-addresses`, token)
        .then((resp) => resp.items ?? []);
}

export function addTeamPayoutAddress(
    token: string | null,
    teamId: string,
    address: string,
): Promise<TeamPayoutAddress> {
    return apiFetch<TeamPayoutAddress>(`/teams/${encodeURIComponent(teamId)}/payout-addresses`, token, {
        method: "POST",
        body: JSON.stringify({network: "trc20", address}),
    });
}

export function disableTeamPayoutAddress(token: string | null, teamId: string, addressId: string): Promise<void> {
    return apiFetch<void>(
        `/teams/${encodeURIComponent(teamId)}/payout-addresses/${encodeURIComponent(addressId)}`,
        token,
        {method: "DELETE"},
    );
}

export function listPendingTeamWithdrawals(token: string | null): Promise<TeamWithdrawalPendingResponse> {
    return apiFetch<TeamWithdrawalPendingResponse>("/team-withdrawal-requests?status=pending", token);
}

export function completeTeamWithdrawal(token: string | null, requestId: string): Promise<unknown> {
    return apiFetch<unknown>(`/team-withdrawal-requests/${encodeURIComponent(requestId)}/complete`, token, {
        method: "POST",
    });
}

export function cancelTeamWithdrawal(token: string | null, requestId: string): Promise<unknown> {
    return apiFetch<unknown>(`/team-withdrawal-requests/${encodeURIComponent(requestId)}/cancel`, token, {
        method: "POST",
    });
}

export function formatTeamWithdrawalError(err: unknown): string {
    if (err instanceof ApiError) {
        switch (apiErrorCode(err)) {
            case "invalid_address":
                return "Некорректный TRON-адрес: проверьте формат и контрольную сумму.";
            case "address_already_bound":
                return "Этот адрес уже занят другой командой или депозитным адресом мерчанта.";
            case "pending_withdrawal_request":
                return "На этот адрес висит активный запрос вывода: сначала завершите или отмените его.";
            case "no_payout_address":
                return "Команде не привязан адрес вывода.";
            case "withdrawal_request_exists":
                return "У команды уже есть активный запрос вывода.";
            case "nothing_to_withdraw":
                return "Выводить нечего: положительного долга по мерчантам нет.";
            case "withdrawal_request_not_pending":
                return "Запрос уже завершён или отменён.";
            default:
                break;
        }
    }
    return formatApiError(err);
}
